import { faEdit, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EmptyList from 'components/common/EmptyList';
import FalconComponentCard from 'components/common/FalconComponentCard';
import Flex from 'components/common/Flex';
import DialogModal from 'components/modals/DialogModal';
import { useFormatDateTime } from 'hooks/useFormatDateTime';
import useNotification from 'hooks/useNotification';
import { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import BusinessScheduleService from 'services/BusinessSchedule.service';

const BusinessScheduleList = () => {
  const { showSuccessNotification, showErrorNotification } = useNotification();
  const formatDateTime = useFormatDateTime();
  const [isLoading, setIsLoading] = useState(false);
  const [schedules, setSchedules] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState({});
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    const response = await BusinessScheduleService.list();
    if (Array.isArray(response)) setSchedules(response);
    setIsLoading(false);
  };

  const handleDeleteClick = item => {
    setSelectedSchedule(item);
    setShowDialog(true);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  const deleteSchedule = async confirmed => {
    if (!confirmed) return;

    const response = await BusinessScheduleService.delete(selectedSchedule.id);

    if (response.userMessage) {
      showErrorNotification(response.userMessage);
    } else {
      showSuccessNotification('Horário comercial excluído com sucesso');
      getData();
    }

    handleCloseDialog();
  };

  const isEmpty = !isLoading && schedules.length === 0;

  return (
    <>
      <DialogModal
        message="Tem certeza que deseja excluir este horário comercial?"
        showModal={showDialog}
        handleClose={handleCloseDialog}
        response={deleteSchedule}
      />

      <FalconComponentCard>
        <FalconComponentCard.Header
          title="Horários Comerciais"
          subTitle="Configure os horários comerciais da sua empresa. Eles serão utilizados nas políticas de SLA."
        >
          <div className="w-100 d-flex justify-content-between">
            <Link
              to="/settings/business-schedules/new"
              className="btn btn-primary btn-sm"
            >
              <FontAwesomeIcon icon={faPlus} size="sm" className="me-2" />
              Novo
            </Link>
          </div>
        </FalconComponentCard.Header>

        <FalconComponentCard.Body>
          {isLoading ? (
            <Skeleton count={4} height={80} baseColor="#5E6E82" />
          ) : isEmpty ? (
            <EmptyList imgSize={400} vhSize={73} />
          ) : (
            schedules.map(schedule => (
              <Card className="mb-3" key={schedule.id}>
                <Card.Body>
                  <Flex justifyContent="between" alignItems="center">
                    <div>
                      <Link
                        to={`/settings/business-schedules/${schedule.id}/edit`}
                        className="fw-semi-bold"
                      >
                        {schedule.name}
                      </Link>
                      {schedule.description && (
                        <p className="fs-10 mt-1 mb-0 text-600">
                          {schedule.description}
                        </p>
                      )}
                      <div className="mt-2 d-flex gap-3">
                        {schedule.creationDate && (
                          <span className="fs-11 text-500">
                            Criado em: {formatDateTime(schedule.creationDate)}
                          </span>
                        )}
                        {schedule.lastUpdateDate && (
                          <span className="fs-11 text-500">
                            Atualizado em: {formatDateTime(schedule.lastUpdateDate)}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <Link
                        to={`/settings/business-schedules/${schedule.id}/edit`}
                        className="btn btn-link btn-sm p-1"
                        title="Editar"
                      >
                        <FontAwesomeIcon icon={faEdit} size="sm" />
                      </Link>
                      <button
                        className="btn btn-link btn-sm p-1 text-danger"
                        onClick={() => handleDeleteClick(schedule)}
                        title="Excluir"
                      >
                        <FontAwesomeIcon icon={faTrash} size="sm" />
                      </button>
                    </div>
                  </Flex>
                </Card.Body>
              </Card>
            ))
          )}
        </FalconComponentCard.Body>
      </FalconComponentCard>
    </>
  );
};

export default BusinessScheduleList;
